import React, { useState, useEffect } from "react";
import { Loader2, ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import api from "@/lib/api";

export function loadRazorpayScript() {
  return new Promise((resolve) => {
    if (window.Razorpay) return resolve(true);
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
}

export default function RazorpayCheckout({ applicationId, amount, currency, customerName, customerWhatsapp, onSuccess, autoOpen = false }) {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (autoOpen) handlePay();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePay = async () => {
    setLoading(true);
    try {
      const loaded = await loadRazorpayScript();
      if (!loaded) {
        toast.error("Failed to load payment gateway. Please check your connection.");
        setLoading(false);
        return;
      }
      const { data: order } = await api.post("/payments/create-order", { application_id: applicationId, currency });

      const options = {
        key: order.key_id,
        amount: order.amount,
        currency: order.currency,
        name: "Gulfudaan",
        description: `Application ${order.application_number}`,
        order_id: order.order_id,
        prefill: { name: customerName, contact: customerWhatsapp },
        theme: { color: "#b1976b" },
        handler: async (response) => {
          try {
            await api.post("/payments/verify", {
              application_id: applicationId,
              razorpay_order_id: response.razorpay_order_id,
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_signature: response.razorpay_signature,
            });
            toast.success("Payment successful! Application confirmed.");
            onSuccess && onSuccess();
          } catch (e) {
            toast.error("Payment verification failed. Please contact support.");
          }
        },
        modal: { ondismiss: () => setLoading(false) },
      };
      const rzp = new window.Razorpay(options);
      rzp.open();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Failed to initiate payment");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button data-testid="razorpay-pay-now-btn" onClick={handlePay} disabled={loading}
      className="w-full bg-[var(--brand-primary)] hover:bg-[#9E855A] text-white h-12 text-base">
      {loading ? <Loader2 className="animate-spin mr-2" size={18} /> : <ShieldCheck className="mr-2" size={18} />}
      Pay Now {currency === "INR" ? "₹" : "$"}{amount}
    </Button>
  );
}
